'use strict';

const isTabletPortraitView = () => {
    const tabletminWidth = 768;
    const tabletMaxWidth = 900;
    const vpWidth = $(window).width();

    return vpWidth >= tabletminWidth && vpWidth < tabletMaxWidth;
};

module.exports = isTabletPortraitView;
